<div class="contenedorDetalle">
  <div class="detalleHeader">
    <h2>
      Detalle Contratista: {{ contratista?.nombreComercial }}
    </h2>
    <div class="displayFlex botonesDetalle">
      <div *ngIf="path !== '/cliente/contratistas'">
        <button (click)="disableInput()">Editar</button>
      </div>
      <!-- <button class="button__secondary">Imprimir</button>
      <button class="button__secondary">Descarga</button> -->
    </div>
  </div>
  <div>
    <form novalidate [formGroup]="detalleContratista" class="detalleContenido">
      <div>
        <h3>Datos Perfil Contratista</h3>
        <div class="datos__detalle">
          <div>
            <label for="razonSocial">Razón Social</label>
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="razonSocial"
              id="razonSocial"
            />
          </div>
          <div>
            <label for="cif">CIF</label>
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="cif"
              id="cif"
            />
          </div>
          <div>
            <label for="nombreComercial">Nombre Comercial</label>
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="nombreComercial"
              id="nombreComercial"
            />
          </div>
        </div>

        <div formGroupName="direccion" class="displayFlex domicilioFiscal">
          <label for="direccion">Domicilio Fiscal</label>

          <input
            [attr.disabled]="disableInputBox ? true : null"
            type="text"
            formControlName="via"
            id="via"
          />
          <input
            [attr.disabled]="disableInputBox ? true : null"
            type="text"
            formControlName="nombreVia"
            id="nombreVia"
          />

          <input
            [attr.disabled]="disableInputBox ? true : null"
            type="text"
            formControlName="provincia"
            id="provincia"
          />
          <input
            [attr.disabled]="disableInputBox ? true : null"
            type="text"
            formControlName="ccaa"
            id="ccaa"
          />

          <input
            [attr.disabled]="disableInputBox ? true : null"
            type="text"
            formControlName="codigoPostal"
            id="codigoPostal"
          />
        </div>
        <div class="displayFlex">
          <label for="actividad">Actividad de la Empresa</label>
          <input
            [attr.disabled]="disableInputBox ? true : null"
            type="text"
            formControlName="actividad"
            id="actividad"
          />
        </div>

        <div formGroupName="contacto">
          <h3>Datos de contacto</h3>
          <div class="datos__detalle">
            <div class="displayFlex">
              <label for="contactoNombre">Persona de Contacto</label>
              <input
                [attr.disabled]="disableInputBox ? true : null"
                type="text"
                formControlName="contactoNombre"
                id="contactoNombre"
              />
            </div>
            <div class="displayFlex">
              <label for="cargo">Cargo</label>
              <input
                [attr.disabled]="disableInputBox ? true : null"
                type="text"
                formControlName="cargo"
                id="cargo"
              />
            </div>
            <div class="displayFlex">
              <label for="mailContacto">Mail de Contacto</label>
              <input
                [attr.disabled]="disableInputBox ? true : null"
                type="text"
                formControlName="contactoMail"
                id="mailContacto"
              />
            </div>
          </div>
        </div>
        <div *ngIf="!disableInputBox">
          <button (click)="updateContratistaById()">Guardar</button>
        </div>
      </div>
    </form>
    <a *ngIf="path === '/cliente/contratistas'" [routerLink]="['cliente/centros']"
     (click)="setIdContratista(contratista.id)" [mat-dialog-close]>
      Ir a tabla Centros
    </a>
    <a *ngIf="path === '/inproeco/estado/contratistas'" [routerLink]="['inproeco/estado/centros']"
     (click)="setIdContratista(contratista.id)" [mat-dialog-close]>
      Ir a tabla Centros
    </a>
    <div>
      <h3>Clientes</h3>
      <div
        *ngIf="contratista?.clientes?.length; else elseBlock"
        class="displayFlex"
      >
        <div *ngFor="let cliente of contratista?.clientes">
          <p class="clientes">{{ cliente?.nombreComercial }}</p>
        </div>
      </div>
      <ng-template #elseBlock>-</ng-template>
    </div>
    <div>
      <h3>Gestores</h3>
      <div
        *ngIf="contratista?.gestores?.length; else elseBlock"
        class="displayFlex"
      >
        <div *ngFor="let gestor of contratista?.gestores">
          <p class="gestores">{{ gestor?.nombre }}</p>
        </div>
      </div>
      <ng-template #elseBlock>-</ng-template>
    </div>
    <div>
      <h3>Transportistas</h3>
      <div
        *ngIf="contratista?.transportistas?.length; else elseBlock"
        class="displayFlex"
      >
        <div *ngFor="let transportista of contratista?.transportistas">
          <p class="transportistas">{{ transportista?.nombre }}</p>
        </div>
      </div>
      <ng-template #elseBlock>-</ng-template>
    </div>
  </div>
</div>
